import { ReactNode } from "react";

import "./Page.css";

export type PageProps = {
  puck: any;
  centered?: boolean;
  children: ReactNode;
};

const Page = ({ puck, centered, children }: PageProps) => (
  <div
    className={`${puck.isEditing ? "py-16 px-[8px] w-full" : ""} msrd-Page${
      centered ? " msrd-Page--centered" : ""
    }`}
  >
    <main className="msrd-Page-main">{children}</main>
  </div>
);

export default Page;
